<div *ngIf="!isRuta">
    <div *ngFor="let achievement of achievementsForEdit; let i = index">
        <app-inputs-achievements 
            [disable]="disable"  
            [achievement]="achievement" 
            [i]="i"
            [mode]="mode" 
            (removeAchievementEvent)="removeAchievementFromEdit(i)" 
            (saveAchievementEvent)="saveAchievementFromInputComponentFromEdit($event)">
        </app-inputs-achievements>
    </div>
    <div *ngFor="let achievement of achievements; let i = index">
        <app-inputs-achievements 
            [disable]="disable"
            [i]="i"
            [mode]="mode" 
            (removeAchievementEvent)="removeAchievement(i)" 
            (saveAchievementEvent)="saveAchievementFromInputComponent($event)"></app-inputs-achievements>
    </div>
</div>

<div *ngIf="isRuta">
    <div *ngFor="let achievement of achievementsRouteForEdit; let i = index">
        <app-inputs-achievements 
            [disable]="disable"
            [achievement]="achievement"
            [i]="i"
            [mode]="mode"
            (removeAchievementEvent)="removeAchievementFromEdit(i)"
            (saveAchievementEvent)="saveAchievementRouteFromInputComponentFromEdit($event)">
        </app-inputs-achievements>
    </div>
    <div *ngFor="let achievement of achievementsRoute; let i = index">
        <app-inputs-achievements 
            [disable]="disable" 
            [i]="i"
            [mode]="mode"
            (removeAchievementEvent)="removeAchievement(i)"
            (saveAchievementEvent)="saveAchievementFromInputComponent($event)">
        </app-inputs-achievements>
    </div>
</div>
    
<button 
    (click)="addAchievement()" 
    (keydown.enter)="$event.preventDefault()"
    *ngIf="!disable" 
    [disabled]="disable"  
    mat-button color="primary" 
    id="addButton">
    {{ 'registration.stepThree.objetives.add' |translate}}
</button>

<!-- <button (click)="mostrar()" >
    mostrar
</button> -->